import React from 'react';

import { PaymentMethod } from '../common/Constants';
import { formatNumber, getCurrencySymbol } from '../common/Formatter';
import { useTranslation } from 'react-i18next';

export type QuotedVariantPriceProps = {
  monthlyPrice?: number;
  totalPrice?: number;
  paymentMethod?: string;
  noOfInstallments?: number;
  culture: string;
};

const QuotedVariantPrice = ({
  monthlyPrice,
  totalPrice,
  paymentMethod,
  noOfInstallments,
  culture
}: QuotedVariantPriceProps): JSX.Element => {
  const currencySymbol = getCurrencySymbol();
  const { t } = useTranslation();
  return (
    <>
      <div className='variant-price'>
        <div>{t('customer-product-page.your-quote')}</div>
        {paymentMethod === PaymentMethod.Single && monthlyPrice && (
          <>
            <span className='bold'>{`${currencySymbol}${formatNumber(
              monthlyPrice,
              2,
              culture
            )}`}</span>
            <p className='label'>{t('customer-product-page.single-payment')}</p>
          </>
        )}
        {paymentMethod === PaymentMethod.Monthly &&
          monthlyPrice &&
          totalPrice &&
          noOfInstallments && (
            <>
              <div>
                <p className={`bold`}>
                  {currencySymbol}
                  {formatNumber(monthlyPrice, 2, culture)}/
                  {t('customer-product-page.per-month-text')}
                </p>
                <p className='label'>
                  {t('customer-product-page.total-installments-text', {
                    totalNumberOfInstallments: noOfInstallments.toString()
                  })}
                </p>
                <p className='bold'>{`${t('customer-single-payment.subscription-total')} ${currencySymbol}${formatNumber(
                  totalPrice,
                  2,
                  culture
                )}`}</p>
              </div>
            </>
          )}
        {paymentMethod === PaymentMethod.Subscription &&
          monthlyPrice &&
          totalPrice && (
            <>
              <div>
                <p className={`bold`}>
                  {`${currencySymbol}${formatNumber(
                    monthlyPrice,
                    2,
                    culture
                  )}/`}
                  {t('customer-product-page.per-month-text')}
                </p>
                <p className='label'>
                  {t('customer-product-page.ongoing-until-terminated')}
                </p>
              </div>
            </>
          )}
      </div>
    </>
  );
};

export default QuotedVariantPrice;
